import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AeonyxWordmark } from "@/components/aeonyx/Logo";
import AuthForm from "@/components/auth/AuthForm";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { openAuth } = useAuth();

  return (
    <div className="min-h-screen bg-cool-white flex items-center justify-center px-5 py-16 relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-60 bg-[radial-gradient(circle_at_20%_20%,rgba(1,207,198,0.14),transparent_50%),radial-gradient(circle_at_80%_60%,rgba(2,47,107,0.09),transparent_55%)]"
      />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Link to="/" aria-label="Home">
            <AeonyxWordmark className="h-12 w-auto" />
          </Link>
        </div>
        <div className="rounded-3xl border border-[#8A97A8]/25 bg-white/95 backdrop-blur-xl p-8 shadow-[0_30px_60px_-20px_rgba(2,47,107,0.2)]">
          <AuthForm
            mode="reset"
            onModeChange={(m) => {
              if (m === "signin") navigate("/login");
            }}
            onSuccess={() => {
              openAuth("signin");
              navigate("/login");
            }}
            compact
          />
        </div>
      </div>
    </div>
  );
}
